import { LinearProgress, CircularProgress, Button } from '@material-ui/core';
import { GroupedVirtuoso as GroupedVirtuosoComponent } from 'react-virtuoso';
import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const BlankComponent = lib.styled.div`
  height: 30px;
`;

export const GroupedVirtuoso = lib.styled(GroupedVirtuosoComponent)`
  margin: 0 10px 0 10px;
 
`;

export const EmptyStateComponent = lib.styled.div`
  display: flex;
  flex: 1;
  height: inherit;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  opacity: 0.5;
  color: ${colors.darkGray02}!important;
  & > svg: {
    fontSize: 4.0rem;
  };
  & > p: {
    color: ${colors.darkGray02}!important;
  };

  .subtitle {
    margin: 0 10px 0 10px;
    font-size: 0.9rem;
    text-align: center;
  }
`;

export const LoadingContainer = lib.styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 25px;
`;

export const LinearLoader = lib.styled(LinearProgress)`
  width: 100%;

  &.MuiLinearProgress-root {
    height: 2px;
  }

  &.MuiLinearProgress-colorPrimary {
    background-color: ${colors.lightGreen02};
  }

  & .MuiLinearProgress-barColorPrimary {
    background-color: ${colors.green02};
  }
`;

export const SectionHeader = lib.styled.div`
  display: flex;
  flex: 1;
  height: 30px;
  align-items: center;
  justify-content: center;
  background-color: ${colors.white};
  padding: 2px 0 2px 0;
  margin-top: -3px;

  .line {
    height: 1px;
    background-color: ${colors.lightGray06};
    flex: 1;
  }

  span {
    padding: 0 8px 0 8px;
    font-weight: bold;
    font-size: 12px;
    color: ${colors.black};
    opacity: 0.5;
  }
`;

export const CircularLoader = lib.styled(CircularProgress)`
  margin-top: 50px;
  
  &.MuiCircularProgress-root {
    margin-bottom: 10px;
  }

  &.MuiCircularProgress-colorPrimary {
     color: ${colors.green02};
  }
`;

export const LoadMoreBtn = lib.styled(Button)`
  &.MuiButton-root {
    border-radius: 35px;
    margin-bottom: 10px;
  }

  &.MuiButton-outlined {
    border: 1px solid ${colors.lightGreen02};
  }
`;

export const Center = lib.styled.div`
  display: flex;
  justify-content: center;
`;

export const CallInfo = lib.styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0.5;
  gap: 10px;
  margin: 15px 10px 0 10px;
  
  span {
    font-size: 14px;
  }
`;

export const RefreshButton = lib.styled.button`
  width: 40px;
  height: 40px;
  background: ${colors.white};
  border: none;
  border-radius: 50px;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
  color: ${colors.darkGray02};
  padding-top: 3px;
  cursor: pointer;
`;

export const FooterWrapper = lib.styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding-bottom: 20px;
`;

export const FooterLoading = lib.styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 0 15px 0;
`;
